import React, { useState } from "react";
import { Modal } from "react-responsive-modal";
import Button from "components/CustomButton";
import { ReactComponent as BinIcon } from "assets/img/icons/bin.svg";

var styles = {
  titleDailog: {
    padding: "24px 24px 10px",
    fontSize: "1.25rem",
    fontWeight: "900",
    marginBottom: "0",
  },
  headingDailog: {
    fontSize: "1rem",
    padding: "0px 24px",
    marginBottom: "12px",
  },
  actionButton: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    textAlign: "center",
    padding: "0",
  },
  cursor: {
    cursor: "pointer",
  },
};

export default ({ deleteMyExpression, setHide = null }) => {
  const [dialogState, setDialogState] = useState(false);
  const classes = styles;

  const displayDeleteModal = () => {
    if(setHide) setHide(true);
    setDialogState(true);
  };

  const closeDeleteModal = () => {
    setDialogState(false);
    if(setHide) setHide(false);
  };

  const deleteTheExpression = async () => {
    await deleteMyExpression();
    closeDeleteModal();
  };

  return (
    <>
      <span className="p-c-like t-d-none">
        <BinIcon style={classes.cursor} onClick={displayDeleteModal} />
      </span>
      <Modal
        open={dialogState}
        onClose={closeDeleteModal}
        showCloseIcon={false}
        classNames={{
          modalContainer: "modalContainer",
          modal: "rootModalContainer",
        }}
      >
        <div className="deleteConfirmationModal confirmationModalContent">
          <h5 className="text-center confirmationModalHeader">
            Delete Comment
          </h5>
          <h6 className="confirmationModalDescription">
            Do you want to delete this comment, kindly confirm.
          </h6>
          <div className="confirmationModalFooter">
            <Button buttonClass="small-btn me-2" onClick={closeDeleteModal}>
              Cancel
            </Button>
            <Button
              onClick={deleteTheExpression}
              buttonClass=" small-reject-btn "
            >
              Confirm
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
};
